import React from 'react';
import { getOptions as fetchOptions } from '@/services';

export default function () {
  const [options, setOptions] = React.useState<Partial<Record<API.OptionType, API.Option[]>>>({});

  const refreshOptions = React.useCallback(
    async (type: API.OptionType) => {
      const res = await fetchOptions(type);
      setOptions((prevState) => {
        const newState = { ...prevState };
        newState[type] = res.data;
        return newState;
      });
      return res.data;
    },
    [],
  );

  const getOptions = React.useCallback(
    async (type: API.OptionType, forceRefresh = false) => {
      if (!forceRefresh && options[type]) {
        return Promise.resolve(options[type]);
      } else {
        return refreshOptions(type);
      }
    },
    [options, refreshOptions],
  );

  return { getOptions, refreshOptions, options };
}
